import { Stack } from "@mui/material";
import * as React from "react";
import { generateBorder } from "../../lib/generateBorder";
import { generateRadius } from "../../lib/generateRadius";
import { generateSide } from "../../lib/generateSide";
import { IXGridProps } from "../../utils/interfaces/containers/Old_XGrid.interfaces";

export const Grid: React.FC<IXGridProps & { children?: React.ReactNode }> = (
  props
) => {
  return (
    <Stack
      sx={{
        position: "relative",

        display: "grid",

        gridTemplateColumns: `repeat(${props.columns ?? 3}, 1fr)`,

        gridTemplateRows: "1fr",

        gap: props.gap,

        boxSizing: "border-box",

        flexDirection: props.direction ?? "column",

        justifyContent: props.justifyContent ?? "flex-start",

        alignItems: props.alignItems ?? "flex-start",

        backgroundColor: props.bgColor,

        width: props.width,

        height: props.height,

        margin: generateSide("margin", props.margin) as any,

        padding: generateSide("padding", props.padding) as any,

        border: generateBorder(props.border),

        borderRadius: generateRadius(props.borderRadius),

        gridColumn: `span ${parseInt(props.colSpan?.toString() ?? "1")}`,

        gridRow: `span ${parseInt(props.rowSpan?.toString() ?? "1")}`,

        "& > *": {
          gridColumn: "auto",

          gridRow: "auto",
        },
      }}
    >
      {props.children}
    </Stack>
  );
};
